(function() {

  // ── REVIEWS BADGE (silent open, grab rating, close) ──
  function initReviewsBadge(detailsEl) {
    var badge = null;

    function createBadge(avg, stars, count) {
      var headingEl = detailsEl.querySelector('.faq__summary-heading');
      if (!headingEl || headingEl.querySelector('.faq__reviews-badge')) return;

      badge = document.createElement('span');
      badge.className = 'faq__reviews-badge';
      badge.style.cssText = 'display:inline-flex;align-items:baseline;gap:6px;font-size:14px;font-weight:400;vertical-align:middle;margin-left:5px;';

      var avgSpan = document.createElement('span');
      avgSpan.textContent = avg;
      avgSpan.style.fontWeight = '600';

      badge.appendChild(avgSpan);
      badge.appendChild(stars);

      var countSpan = document.createElement('span');
      countSpan.textContent = count;
      countSpan.style.color = '#555';
      badge.appendChild(countSpan);

      headingEl.appendChild(badge);

      detailsEl.addEventListener('toggle', function() {
        badge.style.display = detailsEl.open ? 'none' : 'inline-flex';
      });
    }

function buildEmptyStars() {
  var starsEl = document.createElement('span');
  starsEl.style.cssText = 'display:inline-flex;gap:2px;';
  for (var i = 0; i < 5; i++) {
    var star = document.createElement('span');
    star.style.cssText = 'font-family:reviewsio-font !important;font-style:normal;color:transparent;-webkit-text-stroke:1.5px #0E1311;';
    star.textContent = '\ue932';
    starsEl.appendChild(star);
  }
  return starsEl;
}

function silentInit() {
  detailsEl.setAttribute('open', '');
  var attempts = 0;
  var poll = setInterval(function() {
    attempts++;
    var avg   = detailsEl.querySelector('.R-TextHeading--md');
    var stars = detailsEl.querySelector('.R-RatingStars__stars');
    var count = detailsEl.querySelector('.R-TextBody--xs');

    if (avg && stars && count) {
      clearInterval(poll);
      var avgText    = avg.textContent.trim();
      var starsClone = stars.cloneNode(true);
      var countText  = count.textContent.trim();
      detailsEl.removeAttribute('open');
      createBadge(avgText, starsClone, countText);
      return;
    }

    if (attempts > 50) {
      clearInterval(poll);
      detailsEl.removeAttribute('open');
      // No reviews found — show zero state
      createBadge('0', buildEmptyStars(), 'Based on 0 reviews');
    }
  }, 100);
}



    setTimeout(silentInit, 300);
  }

  // ── REVIEWS WIDGET (lazy load on accordion open) ──
  function initReviewsWidget(detailsEl, widgetId, sku) {
    var initialized = false;

    function createWidget() {
      new ReviewsWidget('#' + widgetId, {
        store: 'easyblinds.com',
        widget: 'polaris',
        options: {
          types: 'product_review,questions',
          enable_sentiment_analysis: true,
          lang: 'en',
          layout: '',
          per_page: 15,
          store_review: { hide_if_no_results: false },
          third_party_review: { hide_if_no_results: false },
          product_review: { sku: sku, hide_if_no_results: false },
          questions: { hide_if_no_results: false, enable_ask_question: true, enable_ask_question_button_style: false, show_dates: true, grouping: sku },
          header: { enable_summary: true, enable_ratings: true, enable_attributes: true, enable_image_gallery: true, enable_percent_recommended: false, enable_write_review: true, enable_ask_question: true, enable_sub_header: true, rating_decimal_places: 2, use_write_review_button: false, enable_if_no_results: false, show_review_title_field: false },
          sentiment: { badge_text: 'Our Customers Say' },
          filtering: { enable: true, enable_text_search: true, enable_sorting: true, enable_product_filter: false, enable_media_filter: true, enable_overall_rating_filter: true, enable_language_filter: false, enable_language_filter_language_change: false, enable_ratings_filters: true, enable_attributes_filters: true, enable_expanded_filters: false },
          reviews: { enable_avatar: true, enable_reviewer_name: true, enable_reviewer_address: true, reviewer_address_format: 'city, country', enable_verified_badge: true, enable_subscriber_badge: true, review_content_filter: 'undefined', enable_reviewer_recommends: true, enable_attributes: true, enable_product_name: true, enable_link_product: false, enable_review_title: undefined, enable_replies: true, enable_images: true, enable_ratings: true, enable_share: true, enable_helpful_vote: true, enable_helpful_display: true, enable_report: true, enable_date: true, date_format: 'undefined', date_location: 'undefined', enable_third_party_source: true, enable_duplicate_reviews: undefined, combine_title_stars: true },
        },
        translations: { 'Verified Customer': 'Verified Customer' },
        styles: {
          '--base-font-size': '16px', '--common-button-font-family': 'inherit', '--common-button-font-size': '16px', '--common-button-font-weight': '500', '--common-button-letter-spacing': '0', '--common-button-text-transform': 'none', '--common-button-vertical-padding': '10px', '--common-button-horizontal-padding': '20px', '--common-button-border-width': '2px', '--common-button-border-radius': '0px',
          '--primary-button-bg-color': '#2a2b6c', '--primary-button-border-color': '#2a2b6c', '--primary-button-text-color': '#ffffff',
          '--secondary-button-bg-color': 'transparent', '--secondary-button-border-color': '#0E1311', '--secondary-button-text-color': '#0E1311',
          '--common-star-color': '#0E1311', '--common-star-disabled-color': 'rgba(0,0,0,0.25)', '--medium-star-size': '22px', '--small-star-size': '19px',
          '--heading-text-color': '#0E1311', '--heading-text-font-weight': '600', '--heading-text-font-family': 'inherit', '--heading-text-line-height': '1.4', '--heading-text-letter-spacing': '0', '--heading-text-transform': 'none',
          '--body-text-color': '#0E1311', '--body-text-font-weight': '400', '--body-text-font-family': 'inherit', '--body-text-line-height': '1.4', '--body-text-letter-spacing': '0', '--body-text-transform': 'none',
          '--inputfield-text-font-family': 'inherit', '--input-text-font-size': '14px', '--inputfield-text-font-weight': '400', '--inputfield-text-color': '#0E1311', '--inputfield-border-color': 'rgba(0,0,0,0.2)', '--inputfield-background-color': 'transparent', '--inputfield-border-width': '1px', '--inputfield-border-radius': '0px',
          '--common-border-color': 'rgba(0,0,0,0.15)', '--common-border-width': '1px', '--common-sidebar-width': '190px',
          '--filters-panel-bg-color': 'transparent', '--filters-panel-font-size': '16px', '--filters-panel-text-color': '16px', '--filters-panel-horizontal-padding': '0', '--filters-panel-vertical-padding': '0',
          '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)', '--slider-indicator-button-color': '#0E1311', '--slider-indicator-width': '190px',
          '--badge-icon-color': '#0E1311', '--badge-icon-font-size': 'inherit', '--badge-text-color': '#0E1311', '--badge-text-font-size': 'inherit', '--badge-text-letter-spacing': 'inherit', '--badge-text-transform': 'inherit',
          '--author-font-size': 'inherit', '--author-text-transform': 'none',
          '--avatar-thumbnail-size': '60px', '--avatar-thumbnail-border-radius': '100px', '--avatar-thumbnail-text-color': '#0E1311', '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
          '--photo-video-thumbnail-size': '80px', '--photo-video-thumbnail-border-radius': '0px',
          '--mediaslider-scroll-button-icon-color': '#0E1311', '--mediaslider-scroll-button-bg-color': 'rgba(255,255,255,0.85)', '--mediaslider-overlay-text-color': '#ffffff', '--mediaslider-overlay-bg-color': 'rgba(0,0,0,0.8)', '--mediaslider-item-size': '110px',
          '--pagination-tab-text-color': '#0E1311', '--pagination-tab-text-transform': 'none', '--pagination-tab-text-letter-spacing': '0', '--pagination-tab-text-font-size': '16px', '--pagination-tab-text-font-weight': '600', '--pagination-tab-active-text-color': '#0E1311', '--pagination-tab-active-text-font-weight': '600', '--pagination-tab-active-border-color': '#0E1311', '--pagination-tab-border-width': '3px',
          '--sentiment-base-font-size': '15px', '--sentiment-panel-bg-color': 'transparent', '--sentiment-panel-border-size': '1px', '--sentiment-panel-border-color': 'rgba(0,0,0,0.1)', '--sentiment-panel-border-radius': '0px', '--sentiment-panel-shadow-size': '0px', '--sentiment-panel-shadow-color': 'rgba(0,0,0,0.1)',
          '--sentiment-heading-text-color': '#0E1311', '--sentiment-heading-text-font-weight': '600', '--sentiment-heading-text-font-family': 'inherit', '--sentiment-heading-text-line-height': '1.4', '--sentiment-heading-text-letter-spacing': '0', '--sentiment-heading-text-transform': 'none',
          '--sentiment-body-text-color': '#0E1311', '--sentiment-body-text-font-weight': '400', '--sentiment-body-text-font-family': 'inherit', '--sentiment-body-text-line-height': '1.4', '--sentiment-body-text-letter-spacing': '0', '--sentiment-body-text-transform': 'none',
          '--sentiment-panel-vertical-padding': '25px', '--sentiment-panel-horizontal-padding': '20px',
          '--sentiment-header-text-color': 'inherit', '--sentiment-header-text-font-size': '12px', '--sentiment-header-text-font-weight': 'inherit', '--sentiment-header-bg-color': 'rgba(0,0,0,0.04)', '--sentiment-header-border-radius': '50px', '--sentiment-header-shadow-size': '0px', '--sentiment-header-shadow-color': 'rgba(0,0,0,0.1)', '--sentiment-header-vertical-padding': '7px', '--sentiment-header-horizontal-padding': '10px',
          '--sentiment-pagination-tab-text-font-size': '13px', '--sentiment-pagination-tab-text-font-weight': '600', '--sentiment-pagination-tab-text-color': '#0E1311', '--sentiment-pagination-tab-text-transform': 'none', '--sentiment-pagination-tab-text-letter-spacing': '0', '--sentiment-pagination-tab-active-text-color': '#0E1311', '--sentiment-pagination-tab-active-text-font-weight': '600', '--sentiment-pagination-tab-active-border-color': '#0E1311', '--sentiment-pagination-tab-border-width': '3px',
        },
      });
    }

    detailsEl.addEventListener('toggle', function onToggle() {
      if (!detailsEl.open) return;
      detailsEl.removeEventListener('toggle', onToggle);
      if (initialized) return;
      initialized = true;

      if (typeof ReviewsWidget !== 'undefined') {
        createWidget();
        return;
      }
      var s = document.createElement('script');
      s.src = 'https://widget.reviews.co.uk/polaris/build.js';
      s.onload = createWidget;
      document.head.appendChild(s);
    });
  }

  // ── Q&A WIDGET (lazy load on accordion open) ──
  function initQAWidget(detailsEl, widgetId, sku) {
    var initialized = false;

    function loadCSS(href) {
      if (!document.querySelector('link[href="' + href + '"]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = href;
        document.head.appendChild(l);
      }
    }

    function createWidget() {
      questionsWidgetNew(widgetId, {
        store: 'easyblinds.com',
        group: sku,
        hideDates: true,
        css: [
          ['--base-font-size: 16px'], ['--common-button-font-family: inherit'], ['--common-button-font-size: 16px'], ['--common-button-font-weight: 500'], ['--common-button-letter-spacing: 0'], ['--common-button-text-transform: none'], ['--common-button-vertical-padding: 10px'], ['--common-button-horizontal-padding: 25px'], ['--common-button-border-width: 2px'], ['--common-button-border-radius: 0px'],
          ['--primary-button-bg-color: #2a2b6c'], ['--primary-button-border-color: #2a2b6c'], ['--primary-button-text-color: #ffffff'],
          ['--secondary-button-bg-color: transparent'], ['--secondary-button-border-color: #0E1311'], ['--secondary-button-text-color: #0E1311'],
          ['--heading-text-color: #0E1311'], ['--heading-text-font-weight: 600'], ['--heading-text-font-family: inherit'], ['--heading-text-line-height: 1.4'], ['--heading-text-letter-spacing: 0'], ['--heading-text-transform: none'],
          ['--body-text-color: #0E1311'], ['--body-text-font-weight: 400'], ['--body-text-font-family: inherit'], ['--body-text-line-height: 1.4'], ['--body-text-letter-spacing: 0'], ['--body-text-transform: none'],
          ['--inputfield-text-font-family: inherit'], ['--input-text-font-size: 14px'], ['--inputfield-text-font-weight: 400'], ['--inputfield-text-color: #0E1311'], ['--inputfield-border-color: rgba(0,0,0,0.2)'], ['--inputfield-background-color: transparent'], ['--inputfield-border-width: 1px'], ['--inputfield-border-radius: 0px'],
          ['--common-border-color: rgba(0,0,0,0.15)'], ['--common-border-width: 1px'], ['--common-sidebar-width: 190px'],
          ['--badge-icon-color: #0E1311'], ['--badge-icon-font-size: inherit'], ['--badge-text-color: #0E1311'], ['--badge-text-font-size: inherit'], ['--badge-text-letter-spacing: inherit'], ['--badge-text-transform: inherit'],
          ['--author-font-size: inherit'], ['--author-text-transform: none'],
          ['--avatar-thumbnail-size: 60px'], ['--avatar-thumbnail-border-radius: 100px'], ['--avatar-thumbnail-text-color: #0E1311'], ['--avatar-thumbnail-bg-color: rgba(0,0,0,0.1)'],
          ['--pagination-tab-text-color: #0E1311'], ['--pagination-tab-text-transform: none'], ['--pagination-tab-text-letter-spacing: 0'], ['--pagination-tab-text-font-size: 16px'], ['--pagination-tab-text-font-weight: 600'], ['--pagination-tab-active-text-color: #0E1311'], ['--pagination-tab-active-text-font-weight: 600'], ['--pagination-tab-active-border-color: #0E1311'], ['--pagination-tab-border-width: 3px'],
        ]
      });
    }

    detailsEl.addEventListener('toggle', function onToggle() {
      if (!detailsEl.open) return;
      detailsEl.removeEventListener('toggle', onToggle);
      if (initialized) return;
      initialized = true;

      loadCSS('https://assets.reviews.io/css/widgets/qna-widget.css');
      loadCSS('https://assets.reviews.io/iconfont/reviewsio-icons/style.css');

      if (typeof questionsWidgetNew !== 'undefined') {
        createWidget();
        return;
      }
      var s = document.createElement('script');
      s.src = 'https://widget.reviews.co.uk/questions-answers/new/dist.js';
      s.onload = createWidget;
      document.head.appendChild(s);
    });
  }

// ── BOOT: find all widget blocks and initialise ──
document.addEventListener('DOMContentLoaded', function() {

  // Resolve SKU: prefer the dynamic product SKU injected by Liquid,
  // fall back to whatever was entered in the customizer.
  function resolveSku(el) {
    var section = el.closest('section[data-product-sku]');
    var productSku = section ? section.getAttribute('data-product-sku') : '';
    // Use customizer SKU only as a last resort
    return (productSku && productSku.trim() !== '') ? productSku.trim() : (el.dataset.sku || '');
  }

  // Reviews
  document.querySelectorAll('[id^="faq-reviews-"]').forEach(function(el) {
    var widgetDiv = el.querySelector('[id^="reviews-widget-"]');
    if (!widgetDiv) return;
    var widgetId = widgetDiv.id;
    var sku = resolveSku(el);
    initReviewsBadge(el);
    initReviewsWidget(el, widgetId, sku);
  });

  // Q&A
  document.querySelectorAll('[id^="faq-qa-"]').forEach(function(el) {
    var widgetDiv = el.querySelector('[id^="qa-widget-"]');
    if (!widgetDiv) return;
    var widgetId = widgetDiv.id;
    var sku = resolveSku(el);
    initQAWidget(el, widgetId, sku);
  });

});

})();
